// extracted by mini-css-extract-plugin
module.exports = {"officeInfoMenus":"styles_officeInfoMenus__2vICM"};